import { Beat1, Beat2, Beat3 } from "@assets/lottie";

export const beats = [
    {
        title: "BUILDING THE NEW FOREST ECONOMY FROM TREES UP",
        desc: "CTrees’ high-resolution data on carbon, land use, biodiversity, and climate enables the design of credible nature-based solutions, from individual assets to entire jurisdictions, advancing real progress toward a net-zero future.",
        animationData: Beat1,
        chartDesc: "PATH TO NET ZERO IN 2050",
    },
    {
        title: "GROUNDBREAKING SCIENCE FOR POLICY AND FINANCE",
        desc: "CTrees empowers climate policy and finance with science-based carbon data, tracking deforestation, degradation, regrowth, and restoration to support credible decisions at every scale.",
        animationData: Beat2,
        chartDesc: "Nature-Based Climate Solutions",
        chartLeft: true,
        chartWidth: '90%',
    },
    {
        title: "OPERATIONAL DATA FOR NATURE-BASED SOLUTIONS",
        desc: "CTrees provides trusted data to scale nature-based solutions, enabling buyers, investors, and implementers to verify impact, manage risk, and deliver real climate and biodiversity results.",
        animationData: Beat3,
        chartDesc: "GLOBAL FOREST Ecosystem",
        chartWidth: '70%',
    },
];